import type { MatchupReport, ReportManager } from "@averagejoesff/shared";

/** Manager lookup by `ReportManager.id` — built once per report, passed down the tree. */
export type ManagerLookup = ReadonlyMap<string, ReportManager>;

export function indexManagers(report: MatchupReport): ManagerLookup {
  return new Map(report.managers.map((m) => [m.id, m]));
}

/** A manager's display name, falling back to the raw id if the report omitted them. */
export function managerName(managers: ManagerLookup, id: string): string {
  return managers.get(id)?.name ?? id;
}
